import { gql } from "_graphql-types/gql";

export const TOOLTIP_ATTRIBUTES = gql(/* GraphQL */ `
  query TooltipAttributes($id: Int!) {
    investment(id: $id) {
      ...InvestmentTile
    }
  }
`);
